import { AnimationProps } from './Animation.interfaces';

const Animation = ({ children, type }: AnimationProps) => {
  return <div className={`c-animation--${type}`}>{children}</div>;
};

export { Animation };
